import Swiper from 'swiper'
import { Mousewheel, Navigation } from 'swiper/modules'

export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		const reviewsSectionSliderEls = document.querySelectorAll(
			'.section-reviews-carousel-slider-items-wrapper',
		)
		if (reviewsSectionSliderEls) {
			reviewsSectionSliderEls.forEach((reviewsSectionSliderEl) => {
				const sectionEl = reviewsSectionSliderEl.closest('.section-reviews-carousel')
				if (sectionEl) {
					const id = sectionEl.id
					new Swiper(reviewsSectionSliderEl as HTMLElement, {
						modules: [Navigation, Mousewheel],
						slidesPerView: 1,
						centeredSlides: true,
						spaceBetween: 20,
						navigation: {
							prevEl: `#${id} .prev`,
							nextEl: `#${id} .next`,
							disabledClass: 'btn-disabled',
						},
						mousewheel: {
							enabled: true,
							forceToAxis: true,
						},
					})
				}
			})
		}
	})
}
